import {useComparatorData} from "./_useComparatorData.js";
import {isMobile} from "../../util/misc.js";
import {useState} from "react";
import {useChillEffect} from "../../util/mounting-hooks.js";
import {CHART_PALETTE, getChartGradients} from "../assets/chart/_chart-palette.js";
import {useDispatch, useSelector} from "react-redux";
import {
    getAssetId1,
    getAssetId2,
    setAsset1ChangePct,
    setDeltaPercent,
    setFirstDate
} from "../../ducks/comparator-duck.js";
import {ASSET_COLOR_1, ASSET_COLOR_2} from "./_helpers.js";


const dataInitialState = {
    labels: [],
    datasets: [],
    latestValue: 0,
    hasData: false,
    isLive: false,
    trajectory: 'neutral',
}

export const useComparatorChartData = (chartRef) => {

    const dispatch = useDispatch()
    const assetId1 = useSelector(getAssetId1)
    const assetId2 = useSelector(getAssetId2)

    const [data, setData] = useState(dataInitialState)
    const {
        rateRatio1,
        rateRatio2,
        ratioDelta,
        labels,
    } = useComparatorData()

    useChillEffect(() => {

        const finalDelta = ratioDelta[0]
        const asset1Change = rateRatio1[0]

        dispatch(setDeltaPercent(finalDelta))
        dispatch(setAsset1ChangePct(asset1Change))
        dispatch(setFirstDate(labels[labels.length - 1]))

        const {
            lineGradient,
            backgroundGradient,
        } = getChartGradients(finalDelta >= 0 ? CHART_PALETTE.POSITIVE : CHART_PALETTE.NEGATIVE, chartRef)

        setData({
            datasets: [
                {
                    label: 'Delta',
                    data: ratioDelta,
                    pointRadius: 0,
                    pointHoverRadius: 8,
                    borderWidth: isMobile() ? 2.2 : 3.5,
                    // borderColor: lineGradient,
                    borderColor: lineGradient,
                    // backgroundColor: 'transparent',
                    backgroundColor: backgroundGradient,
                    pointHoverBackgroundColor: backgroundGradient,
                    lineTension: 0.15,
                    fill: true,
                },
                {
                    label: 'Ratio 1',
                    data: rateRatio1,
                    pointRadius: 0,
                    pointHoverRadius: 8,
                    borderWidth: isMobile() ? 1 : 1.5,
                    // borderColor: lineGradient,
                    borderColor: ASSET_COLOR_1,
                    backgroundColor: 'transparent',
                    // backgroundColor: backgroundGradient,
                    // pointHoverBackgroundColor: backgroundGradient,
                    lineTension: 0.15,
                    fill: true,
                },
                {
                    label: 'Ratio 2',
                    data: rateRatio2,
                    pointRadius: 0,
                    pointHoverRadius: 8,
                    borderWidth: isMobile() ? 1 : 1.5,
                    // borderColor: lineGradient2,
                    borderColor: ASSET_COLOR_2,
                    backgroundColor: 'transparent',
                    // backgroundColor: backgroundGradient2,
                    // pointHoverBackgroundColor: backgroundGradient2,
                    lineTension: 0.15,
                    fill: true,
                },
            ],
            labels,
        })

    }, [rateRatio1.toString(), assetId1, assetId2])


    return {
        data,
    }
}